import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcCross = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.6208 2.13158L10.0001 7.75866L4.37935 2.13158C3.75942 1.51164 2.75322 1.51164 2.1317 2.13158C1.51176 2.75151 1.51176 3.75294 2.1317 4.37287L7.75243 9.99996L2.1317 15.627C1.51176 16.247 1.51176 17.2484 2.1317 17.8683C2.75322 18.4883 3.75942 18.4883 4.37935 17.8683L10.0001 12.2413L15.6208 17.8683C16.2407 18.4883 17.2469 18.4883 17.8685 17.8683C18.4884 17.2484 18.4884 16.247 17.8685 15.627L12.2477 9.99996L17.8685 4.37287C18.4884 3.75294 18.4884 2.75151 17.8685 2.13158C17.2469 1.51164 16.2407 1.51164 15.6208 2.13158Z",
		fill: "#828599"
	})]
});
const ForwardRef = forwardRef(SvgIcCross);
export default ForwardRef;
